import { ToastBar, Toaster } from 'react-hot-toast'

const CustomToaster = () => {
  return (
    <Toaster
      containerStyle={{
        top: '30px',
      }}
      toastOptions={{
        error: {
          style: {
            fontSize: '16px',
            fontWeight: '400',
            maxWidth: '60vw',
            minWidth: '288px',
            minHeight: '42px',
            borderRadius: '4px',
            border: '1px solid #F02B2B',
            background: '#FEF4F4',
            textAlign: 'start',
          },
        },
      }}
    >
      {t => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {/* Overwrite the default style of the message */}
              <span>{message}</span>
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  )
}

export default CustomToaster
